import React from "react";
import { Moon, Sun } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import {
  changeLayoutMode,
  changeLayoutTopbarColor,
  changeLeftSidebarColorType,
} from "slices/thunk";
import { createSelector } from "@reduxjs/toolkit";

const LightDark = () => {
  const dispatch = useDispatch<any>();

  const changeMode = (mode: any) => {
    dispatch(changeLayoutMode(mode));
    // dispatch(changeLeftSidebarColorType(mode));
    dispatch(changeLayoutTopbarColor(mode));
  };

  // react-redux
  const selectLayoutState = (state: any) => state.Layout;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (layout: any) => ({
      layoutModeType: layout.layoutModeType,
    })
  );

  const { layoutModeType } = useSelector(selectLayoutProperties);

  const mode = layoutModeType === "dark" ? "light" : "dark";

  return (
    <React.Fragment>
    <div className="relative flex items-center h-header">
    <button
        type="button"
        className="relative flex justify-center items-center p-0 h-9 w-9
        transition-[transform,shadow,border-radius] duration-500 ease-[cubic-bezier(0.4,0,0.2,1)]
       hover:bg-topbar-item-bg-hover
        dark:from-indigo-900/40 dark:to-violet-950/60
        rounded-xl 
        hover:shadow-xl
        group backdrop-blur-sm
        border border-white/20 dark:border-zinc-600/50
        hover:border-amber-300/50 dark:hover:border-violet-400/30"
        id="light-dark-mode"
        onClick={() => changeMode(mode)}>
        
        {/* آیکون با اندازه ثابت */}
        <Sun className="absolute size-5 text-gray-600 opacity-100 
            transition-all duration-700 
            group-hover:rotate-180
               hover:bg-topbar-item-bg-hover
            dark:opacity-0 dark:-translate-y-6
            dark:group-hover:text-indigo-400" />
            
        <Moon className="absolute size-5 text-indigo-300 opacity-0 
            transition-all duration-700 
            dark:opacity-100 dark:translate-y-0
        rotate-80
            group-hover:text-violet-400" />
            
        {/* گلوه اثر */}
        <span className="absolute inset-0 rounded-xl 
            bg-[radial-gradient(circle_at_center,_#fff5_0%,_transparent_70%)]
            dark:bg-[radial-gradient(circle_at_center,_#0005_0%,_transparent_70%)]
            pointer-events-none" />
    </button>
</div>
    </React.Fragment>
  );
};

export default LightDark;
